
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DialogInputText from '../../common/client/components/DialogInputText';

import {
    getPricelistData,
    getPricelistReadOnly,
    getPricelistSaveData
} from '../../reducers/project';

import projectGetActions from '../../sagas/project';

import { DATA_OPERATIONS } from '../../reducers/data';

import download from '../common/download';
import OperationList from './OperationList.state';
import PricelistEditorView from './PricelistEditor.view';

const PricelistEditor = () => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const operationReducer = (state, action) => {
        switch (action.type) {
            case 'expand':
                return {
                    ...state,
                    [action.opId]: true
                };
            case 'collapse':
                return {
                    ...state,
                    [action.opId]: false
                };
            default:
                return state;
        }
    }

    const [operationState, operationDispatch] = React.useReducer(operationReducer, {});

    const pricelistData = useSelector(state => getPricelistData(state.project));
    const pricelistSaveData = useSelector(state => getPricelistSaveData(state.project));
    const pricelistReadOnly = useSelector(state => getPricelistReadOnly(state.project));

    const handleCollapseAllClick = () => {
        setOperationStateAll(false);
    }

    const handleEditTitleClick = async () => {
        let result = await DialogInputText.show(
            pricelistData.title,
            'Zadejte název ceníku'
        );
        if (result) {
            projectActions.setPricelistTitle(result.text);
        }
    }

    const handleExpandAllClick = () => {
        setOperationStateAll(true);
    }

    const handleCollapseClick = (operation) => {
        operationDispatch({type: 'collapse', opId: operation.id});
    }

    const handleExpandClick = (operation) => {
        operationDispatch({type: 'expand', opId: operation.id});
    }

    const handlePricelistSaveClick = () => {
        download('cenik.json', null, pricelistSaveData);
    }

    const setOperationStateAll = (expand) => {
        DATA_OPERATIONS.forEach(item => {
            operationDispatch({
                type: (expand ? 'expand' : 'collapse'),
                opId: item.id
            });
        });
    }

    const renderOperationList = () => {
        return (
            <OperationList
                pricelistData={pricelistData}
                readOnly={pricelistReadOnly}
                state={operationState}
                onCollapseClick={handleCollapseClick}
                onExpandClick={handleExpandClick}
            />
        );
    }

    return (
        <PricelistEditorView
            onCollapseAllClick={handleCollapseAllClick}
            onEditTitleClick={handleEditTitleClick}
            onExpandAllClick={handleExpandAllClick}
            onPricelistSaveClick={handlePricelistSaveClick}
            operationList={renderOperationList()}
            pricelistTitle={pricelistData.title}
            readOnly={pricelistReadOnly}
        />
    );
}

export default PricelistEditor;
